import * as React from "react";
import Box from "@mui/material/Box";
import { Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CgiNameIconGrey from "../images/general/CgiNameIconGrey.svg";
import CgiNameIconWhite from "../images/general/CgiNameIconWhite.svg";
import CompassIconGrey from "../images/general/CompassIconGradientGrey.svg";
import CompassIconWhite from "../images/general/CompassIconWhite.svg";

export default function AppIcon() {
  const navigate = useNavigate();

  return (
    <Box
      id="menuBarHCLogo"
      sx={{
        flexDirection: "row",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Box
        sx={{
          flexDirection: "row",
          alignItems: "center",
          "&:hover": {
            cursor: "pointer",
          },
          display: "flex",
        }}
      >
        <Icon sx={{ width: "auto", height: 35 }} onClick={() => navigate("/")}>
          <img
            draggable={false}
            src={location.pathname === "/" ? CompassIconGrey : CompassIconWhite}
            height="35px"
          />
        </Icon>
        <Icon
          sx={{ width: "auto", height: 30, mr: 1.5, ml: 0.8 }}
          onClick={() => navigate("/")}
        >
          <img
            draggable={false}
            src={location.pathname === "/" ? CgiNameIconGrey : CgiNameIconWhite}
            height="30px"
          />
        </Icon>
      </Box>
    </Box>
  );
}
